module.exports = __webpack_public_path__ + "img/mingbai3_3bbae741a.png";